import { render, staticRenderFns } from "./Faturamentos.vue?vue&type=template&id=3a080d0e&"
import script from "./Faturamentos.vue?vue&type=script&lang=js&"
export * from "./Faturamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports